import React, { useState } from 'react';
import { NavLink } from "react-router-dom";

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Badge from '@material-ui/core/Badge';

import AccountBoxTwoToneIcon from '@material-ui/icons/AccountBoxTwoTone';
import GridOnTwoToneIcon from '@material-ui/icons/GridOnTwoTone';
import ImageSearchTwoToneIcon from '@material-ui/icons/ImageSearchTwoTone';
import CenterFocusStrongTwoToneIcon from '@material-ui/icons/CenterFocusStrongTwoTone';
import NotificationsActiveTwoToneIcon from '@material-ui/icons/NotificationsActiveTwoTone';
import LayersTwoToneIcon from '@material-ui/icons/LayersTwoTone';

import ShortTextIcon from '@material-ui/icons/ShortText';
import SubjectIcon from '@material-ui/icons/Subject';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import TocIcon from '@material-ui/icons/Toc';

import FindInPageIcon from '@material-ui/icons/FindInPage';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';

// az ikonok nagysága
const mainListItemsFontSize = "large";

// a lista
const mainList = [
  { text: "Regisztrációs adatok", href: "/user/settings/registration", icon: <ShortTextIcon fontSize='small' /> },
  { text: "Alapadatok", href: "/user/settings/basis", icon: <SubjectIcon fontSize='small' /> },
  { text: "Kiegészítő adatok", href: "/user/settings/other", icon: <ViewHeadlineIcon fontSize='small' /> },
  { text: "Csomag adatok", href: "/user/settings/package", icon: <TocIcon fontSize='small' /> }
];
const areaList = [
  { text: "Üzletkötő Budapest", href: "/match/1", value: 3 },
];

const searchList = [
  { text: "Budapesti cégek", href: "#", value: 3 },
  { text: "Debreceni cégek", href: "#", value: 0 },
];

// a lenyíló listák alaphelyzetben
function close() {
  return {
    user: false,
    area: false,
    search: false
  };
}

export default function MainListItems() {

  const [opener, setOpener] = useState(close());

  const handleClickOpener = (key) => {
    const newOpener = close();
    newOpener[key] = !opener[key];
    setOpener({ ...newOpener });
  };

  // ez egyenlőre nem használt
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
      },
      nested: {
        paddingLeft: theme.spacing(4),
      },
      link: {
        '& span': {
          fontSize: 13
        }
      },
      badge: {
        '& span': {
          top: 4,
          border: `1px solid ${theme.palette.background.paper}`,
          padding: '0 1px',
          fontSize: '.6em',
          height: 16,
          minWidth: 16
        }
      },
      menuitems: {
        background: "#ffffff40",
      }
    }),
  );

  const classes = useStyles();

  // lista generálás
  function generate(items) {
    // az id=index-et le kell váltani uuid-ra
    return items.map((item, index) => {

      return <MenuItem key={`user${index}`} style={{ padding: '0 auto' }}>
        <NavLink exact to={item.href} style={{ display: 'inline-flex' }}>
          <ListItemIcon style={{ paddingLeft: 5 }}>{item.icon}</ListItemIcon>
          <ListItemText className={classes.link}>{item.text}</ListItemText>
        </NavLink>
      </MenuItem >
    });
  }

  // arena lista generálás
  function generateArena(items) {
    // az id=index-et le kell váltani uuid-ra
    return items.map((item, index) => {

      return <MenuItem key={`arena${index}`} style={{ padding: '0 auto' }}>
        <NavLink exact to={item.href} style={{ display: 'inline-flex' }}>
          <ListItemIcon style={{ paddingLeft: 5 }}>
            <Badge className={classes.badge} badgeContent={item.value} color="secondary">
              <CheckBoxOutlineBlankIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText className={classes.link}>{item.text}</ListItemText>
        </NavLink>
      </MenuItem >
    });
  }

  // search lista generálás
  function generateSearch(items) {
    // az id=index-et le kell váltani uuid-ra
    return items.map((item, index) => {

      return <MenuItem key={`search${index}`} style={{ padding: '0 auto' }}>
        <NavLink exact to={item.href} style={{ display: 'inline-flex' }}>
          <ListItemIcon style={{ paddingLeft: 5 }}>
            <Badge className={classes.badge} badgeContent={item.value} color="secondary">
              <FindInPageIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText className={classes.link}>{item.text}</ListItemText>
        </NavLink>
      </MenuItem >
    });
  }

  return <>
    <div>
      <MenuItem button onClick={() => handleClickOpener('user')}>
        <ListItemIcon>
          <AccountBoxTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Felhasználó" />
        {opener.user ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={opener.user} timeout="auto" unmountOnExit>
        <MenuList className={classes.menuitems}>
          {generate(mainList)}
        </MenuList>
      </Collapse>

      <MenuItem button onClick={() => handleClickOpener('area')}>
        <ListItemIcon>
          <GridOnTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Aréna" />
        {opener.area ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={opener.area} timeout="auto" unmountOnExit>
        <MenuList className={classes.menuitems}>
          {generateArena(areaList)}
        </MenuList>
      </Collapse>

      <MenuItem button onClick={() => handleClickOpener('search')}>
        <ListItemIcon>
          <ImageSearchTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Cégkeresés" />
        {opener.search ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={opener.search} timeout="auto" unmountOnExit>
        <MenuList className={classes.menuitems}>
          {generateSearch(searchList)}
          <MenuItem >
            <NavLink exact to='/search' style={{ display: 'inline-flex' }}>
              <IconButton style={{ height: '10px', padding: '0 0 0 7px' }} color='primary' aria-label="add" className={classes.margin}>
                <AddCircleIcon fontSize="small" />
              </IconButton>
            </NavLink>
          </MenuItem>
        </MenuList>
      </Collapse>

      <ListItem button>
        <ListItemIcon>
          <CenterFocusStrongTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Saját" />
      </ListItem>
      <ListItem button>
        <ListItemIcon>
          <NotificationsActiveTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Értesítések" />
      </ListItem>
      <ListItem button>
        <ListItemIcon>
          <LayersTwoToneIcon fontSize={mainListItemsFontSize} />
        </ListItemIcon>
        <ListItemText primary="Csomagok" />
      </ListItem>
    </div>
  </>
};
